import { render } from "./contenedor_ingles.vue?vue&type=template&id=3e5ffbfa&scoped=true"
import script from "./contenedor_ingles.vue?vue&type=script&lang=js"
export * from "./contenedor_ingles.vue?vue&type=script&lang=js"

import "./contenedor_ingles.vue?vue&type=style&index=0&id=3e5ffbfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5ffbfa"]])

export default __exports__